exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload[data-v-3068c788]{border:1px dashed #ccc;text-align:center;padding:12px}", ""]);

// exports
